import "./AcademicCouncil.scss";
import administration from "../../Administration.json";
import AboutUsDynamicPage from '../../Administration Dynamic Page/AdministrationdynamicPage';
import TableComponent from '../../../components/Table/TableComponent';

const AcademicCouncil = () => {

    const academicCouncilPage = administration.academicCouncil[0];
    const columns = ["S.No.", "Name", "Designation & Department", "Position", "Email ID"];
    const rows = [
        { name: "Dr. R. Marimuthu", designation: "Principal", position: "President", Email_id: "nicollege2001@yahoo.co.in" },
        { name: "Dr. Priya C. Nair", designation: "Asst. Prof. & Head, Department of Information Technology", position: "Convenor", Email_id: "priyachandrangathan@gmail.com" },
        { name: "Dr. R. Rajalakshmi", designation: "Asst. Prof. & Head, Department of Computer Science", position: "Member", Email_id: "2001rajalakshmi.cs@nicollege.com" },
        { name: "Dr. S. Padmadevi", designation: "Asst. Prof. & Head, Department of Tamil", position: "Member", Email_id: "padma101978@gmail.com" },
        { name: "Mrs. S. T. Deepa", designation: "Asst. Prof. & Head, Department of Computer Application", position: "Member", Email_id: "deepapramod1972@gmail.com" },
        { name: "Dr. R. P. Dhanya", designation: "Asst. Prof. & Head, Department of Microbiology", position: "Member", Email_id: "rpdhanyasunil@gmail.com" },
        { name: "Dr. V. S. Sangeetha", designation: "Asst. Prof. & Head, Department of Biotechnology (PG)", position: "Member", Email_id: "sangeegodwin@gmail.com" },
        { name: "Dr. M. P. Anupa", designation: "Asst. Prof. & Head, Department of Biotechnology (UG)", position: "Member", Email_id: "anu.priyaa15@gmail.com " },
    ];

    return (
        <section className="academicCouncilPageMainContainer">
            <AboutUsDynamicPage
                title={academicCouncilPage.title}
                content={academicCouncilPage.content}
            />
            <TableComponent
                columns={columns}
                data={rows}
                title="Academic Council Members"
                gap='20px'
            />
        </section>
    )
}

export default AcademicCouncil
